// extracted by mini-css-extract-plugin
export default {"carouselDiv":"Carousel_carouselDiv__9SYIC","prevButton":"Carousel_prevButton__k5S6p","nextButton":"Carousel_nextButton__w-Xmn"};